import React, { useState, useEffect, useRef } from "react";
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Scrollbars } from 'react-custom-scrollbars';
import FeatherIcon from 'feather-icons-react';
import { Spin, Drawer, Input, Space, Form, message, Row, Col, Tabs, Modal, Select, Typography, Table, Tag, Checkbox, Empty, Skeleton, Popover } from "antd";
import AllCancelPopup from './AllCancelPopup';
import { AddUser } from '../style';
import ReportExport from '../ImportExport/ReportExport';
import CustomHtmlParser from '../Email/CustomHtmlParser'
import { setAiData } from '../../../redux/CrmReduxCalls/AiResearch';
import { fetchAccountInteReport, saveAccountInteReport, fetchDomainAvaliability, createAccountDiscover, findAccountDiscoverByName, prospectDiscovery, convertHTMLtoPDF, formatIndustryForHunter, CompanyDataByUser, hunterioLeadDetails, hunterioLeadReserach } from '../../../Api/Services/CompanyApiService'
import { getProductDetails } from '../../../Api/Services/Productapiservice'
import {
    getAllCustomFieldByCompanyAndEntity, findAllCustomOptionsByDropdown
} from '../../../Api/Services/CustomeUIApiService';
import { getCountryData } from '../../../Api/Services/CommonApiService'
import { LeadSave } from '../../../Api/Services/LeadApiServices';
import { getServiceLineDetails } from '../../../Api/Services/ServiceLineApiService'
import { BasicFormWrapper, VerticalFormStyleWrap } from '../../styled';
import { CancelIcon, AiIcon, ReseachAccountIcon } from '../../../components/Icons/Icons';
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';

const { Option } = Select;

const HunterioDepartments = [{ label: "Executive", value: "executive" },
{ label: "IT", value: "it" },
{ label: "Finance", value: "finance" },
{ label: "Management", value: "management" },
{ label: "Sales", value: "sales" },
{ label: "Legal", value: "legal" },
{ label: "Support", value: "support" },
{ label: "HR", value: "hr" },
{ label: "Marketing", value: "marketing" },
{ label: "Communication", value: "communication" },
{ label: "Education", value: "education" },
{ label: "Design", value: "design" },
{ label: "Health", value: "health" },
{ label: "Operations", value: "operations" },
];
const DepartmentModal = ({ companyId, hunderDepartments, onSave, selectedCommaSeparated }) => {
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [display, setDisplay] = useState(false)
    useEffect(() => {
        setSelectedDepartments(selectedCommaSeparated)
    }, [])
    async function IndustryForHunter() {
        setDisplay(true)
        let hideMessage;
        const departments = hunderDepartments.join(', ')
        const hunterDep = HunterioDepartments.map(dep => dep.value).join(', ')
        try {
            hideMessage = message.loading("Loading...", 0);
            const payload = {
                groupA: departments,
                groupB: hunterDep
            }
            const response = await formatIndustryForHunter(companyId, payload)
            const arr = response.groupB.split(',').map(item => item.trim());
            setSelectedDepartments(arr)
            hideMessage();
            setDisplay(false)
        } catch (error) {
            hideMessage();
            setDisplay(false)
            message.error(error)
        }
    }
    return (
        <div>
            <div style={{ padding: 5, border: "1px solid #cdcdcd", borderRadius: 10 }}>
                {hunderDepartments.length ? (
                    hunderDepartments.map((dept, index) => (
                        <Tag key={index} color="blue" style={{ marginBottom: 4, marginRight: 4 }}>
                            {dept}
                        </Tag>
                    ))
                ) : (
                    <p style={{ color: "#999" }}>No departments found</p>
                )}
            </div>

            <div style={{ marginTop: 20 }}>
                <p style={{
                    display: "block",
                    overflow: "hidden",
                    color: "rgba(0, 0, 0, 0.85)",
                    fontWeight: "500",
                    fontSize: "16px",
                    lineHeight: "1.4"
                }}>Map to Hunter.io Departments</p>
                <Checkbox.Group
                    className="ai-checkbox-group"
                    options={HunterioDepartments}
                    value={selectedDepartments}
                    onChange={setSelectedDepartments} // reactive state
                />
            </div>
            <div style={{ marginTop: 10, textAlign: "right" }}>
                <Button size="small"
                    className="gradient-button"
                    onClick={() => IndustryForHunter()}
                    disabled={hunderDepartments?.length === 0 || display}
                    style={{ marginRight: 10, height: "36px" }}
                >
                    <AiIcon />  AI Assist
                </Button>
                <Button size="small" className="button_colors"
                    disabled={display}
                    style={{ height: "36px" }}
                    onClick={() => {
                        onSave(selectedDepartments);
                        Modal.destroyAll();
                    }}
                >
                    <FeatherIcon icon='save' /> Save
                </Button>
            </div>
        </div>
    );
};
DepartmentModal.propTypes = {
    hunderDepartments: PropTypes.array.isRequired,
    onSave: PropTypes.func.isRequired,
    selectedCommaSeparated: PropTypes.array.isRequired,
    companyId: PropTypes.number.isRequired,
};
const Popup = ({ currency, AllLeads, GetAll, pageFrom, dataFrom, openResearchType }) => {
    const dispatch = useDispatch();
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const ENTITY_ID = localData?.allEntity?.find((item) => item.entityKey === 'leads')?.customEntityId
    const [form] = Form.useForm();
    const [form1] = Form.useForm();
    const [form2] = Form.useForm();
    const selectedSeniorityRef = useRef(null);
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [deleteClick1, setDelteClick1] = useState(false)
    const [deleteClick2, setDelteClick2] = useState(false)
    const [deleteClick3, setDelteClick3] = useState(false)
    const [deleteClick4, setDelteClick4] = useState(false)
    const [deleteClick6, setDelteClick6] = useState(false)
    const [deleteClick7, setDelteClick7] = useState(false)
    const [pageLoading, setPageLoading] = useState()
    const [activeKey, setActiveKey] = useState()
    const [displayData, setdispayData] = useState()
    const [display, setDisplay] = useState(false)
    const [exportType, setExportType] = useState()
    const [exportOpen, setExportOpen] = useState(false)
    const [exportType1, setExportType1] = useState()
    const [exportOpen1, setExportOpen1] = useState(false)
    const [researchContent, setResearchContent] = useState()
    const [researchJson, setResearchJson] = useState()
    const [pdfData, setPdfData] = useState()
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [productList, setProductList] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [companyList, setCompanyList] = useState({ display: [], extraData: null, identifier: [] });
    const [dataForLeads, setDataForLeads] = useState({ AccountData: {}, fieldDisable: false })
    // const [companyData, setCompanyData] = useState()
    const [isFormFilled, setIsFormFilled] = useState(false);
    const [isFormFilled1, setIsFormFilled1] = useState(false);
    const [isFormFilled2, setIsFormFilled2] = useState(false);
    const [allCountry, setAllCountry] = useState([])
    const [display2, setDisplay2] = useState(false)
    const [researchLeads, setResearchLeads] = useState([]);
    // const [researchLeads1, setResearchLeads1] = useState([]);
    const [lastSearch, setLastSearch] = useState({});
    const [lastLeadsSearch, setLastLeadsSearch] = useState({});
    const [hasMoreLeads, setHasMoreLeads] = useState(true);
    // const [hasMore, setHasMore] = useState(true)
    // const [hasMore1, setHasMore1] = useState(true)
    const [dataOffset, setDataOffset] = useState(0)
    const [dataLimit] = useState(5)
    const [seniority, setSeniority] = useState([])
    // const [tablePage, setTablePage] = useState();
    const [industryData, setIndustryData] = useState([])
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [open, setOpen] = useState(Array(companyList.display?.length).fill(false));
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dataValue, setDataValue] = useState(null);
    const [checkboxValues, setCheckboxValues] = useState()
    const contentStyle = {
        padding: 100,
        background: '#ffffff',
        borderRadius: 4,
    };
    const content = <div style={contentStyle} />;
    const exportToCSV = (value, data) => {
        setExportType(value)
        setExportOpen(!exportOpen)
        setPdfData(data)
    }
    const downoadFile = async (value) => {
        setDisplay(true)
        let hideMessage;
        try {
            hideMessage = message.loading("generating pdf...", 0);
            const resposne = await convertHTMLtoPDF({
                html: `${researchContent}`
            })
            hideMessage();
            setDisplay(false)
            exportToCSV(value, resposne)
        }
        catch (error) {
            hideMessage();
            setDisplay(false)
            message.error("Failed to generate PDF")
        }
    }
    const closeDrawer = () => {
        setCancelConfirmOpen(false)
        dispatch(setAiData({
            openResearch: false,
            saveTotalLeadCount: null,
            newFunction: null,
            pageFrom: null,
            openResearchData: null,
            openResearchType: null,
        }));
        setdispayData()
        setResearchJson()
        setPdfData()
        setSelectedDepartments([])
        setDisplay(false)
        form.setFieldsValue({
            companyName: null,
            companyDomain: null,
        })
        setResearchContent()
        setResearchJson()
        setIsFormFilled(false);
        setDisplay(false)
        setCompanyList({ display: null, extraData: null, identifier: [] })
        form2.setFieldsValue({
            country: null,
            industry: null,
            instruction: null,
        })
        setIsFormFilled2(false);
        form1.setFieldsValue({
            companyNameResearch: null,
            companyDomainResearch: null,
            productsResearch: [],
            servicesResearch: [],
            targetDepartments: []
        })
        // setActiveKey("3")
        setDataForLeads({ AccountData: {}, fieldDisable: false })
        setIsFormFilled1(false);
        setResearchLeads([])
        // setResearchLeads1([])
        setHasMoreLeads(true)
        setLastLeadsSearch({})
        setDataOffset(0)
    }
    const PageCancel1 = () => {
        if (activeKey === "1") {
            if (researchContent && researchContent !== "") {
                setCancelConfirmOpen(true)
            }
            else {
                closeDrawer()
            }
        } else if (activeKey === "3") {
            if (companyList.display?.length) {
                setCancelConfirmOpen(true)
            }
            else {
                closeDrawer()
            }
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (display2 && researchLeads.length > 0) {
                setCancelConfirmOpen(true)
            }
            else {
                closeDrawer()
            }
        }
    }
    const PageMinimize = () => {
        dispatch(setAiData({
            openResearch: false,
        }));
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    // const parseResponse = (responseData) => {
    //     let html = "";
    //     let json = {};

    //     try {
    //         // ✅ CASE 1: Already an object
    //         if (typeof responseData === "object" && responseData !== null) {
    //             return {
    //                 html: responseData.html || "",
    //                 json: responseData.json || {}
    //             };
    //         }

    //         // ✅ CASE 2: Try parsing as JSON string
    //         if (typeof responseData === "string") {
    //             let cleaned = responseData.trim();

    //             // 🔥 Fix invalid format: {html="",json={}}
    //             if (cleaned.startsWith("{") && cleaned.includes("=")) {
    //                 cleaned = cleaned
    //                     .replace(/(\w+)=/g, '"$1":')   // html= → "html":
    //                     .replace(/'/g, '"');          // single → double quotes
    //             }

    //             try {
    //                 const parsed = JSON.parse(cleaned);
    //                 if (parsed.html || parsed.json) {
    //                     return {
    //                         html: parsed.html || "",
    //                         json: parsed.json || {}
    //                     };
    //                 }
    //             } catch (e) {
    //                 // ignore → move to next case
    //             }

    //             // ✅ CASE 3: Markdown blocks
    //             const htmlMatch = cleaned.match(/```html([\s\S]*?)(```|$)/);
    //             const jsonMatch = cleaned.match(/```json([\s\S]*?)```/);

    //             if (htmlMatch) html = htmlMatch[1].trim();

    //             if (jsonMatch) {
    //                 try {
    //                     json = JSON.parse(jsonMatch[1].trim());
    //                 } catch (e) {
    //                     console.error("JSON block parse error:", e);
    //                 }
    //             }

    //             // ✅ CASE 4: Pure HTML fallback
    //             if (!html && cleaned.startsWith("<")) {
    //                 html = cleaned;
    //             }
    //         }

    //     } catch (err) {
    //         console.error("Parsing failed:", err);
    //     }

    //     return { html, json };
    // };
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick4(true)
        setResearchContent()
        setDisplay(true)
        const { companyName, companyDomain } = values
        const payload = {}
        try {
            const responseData = await fetchAccountInteReport(profile.companyId, companyDomain, companyName, payload)
            if (Array.isArray(responseData) && responseData.length === 0) {
                message.info("No content was found for the selected company and domain");
                loadingRef.current = false;
                setDelteClick4(false)
                setDisplay(false)
            }
            // const { html, json } = parseResponse(responseData);
            setResearchContent(responseData.html)
            setResearchJson(responseData.json)
            // const match = responseData.match(/```html([\s\S]*?)(```|$)/);
            // const htmlContent = match ? match[1].trim() : responseData.trim();
            // setResearchContent(htmlContent)
            // const jsonMatch = responseData.match(/```json([\s\S]*?)```/);
            // const jsonContent = jsonMatch ? jsonMatch[1].trim() : responseData.trim();
            // setResearchJson(jsonContent)
            setDisplay(false)
            setdispayData({ companyName, companyDomain })
            loadingRef.current = false;
            setDelteClick4(false)
        }
        catch (error) {
            loadingRef.current = false;
            setDelteClick4(false)
            setDisplay(false)
            message.error(String(error));
            // message.error("The AI API key is invalid or not configured. Please contact your admin")
        }
    }
    const onSubmit1 = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick3(true)
        let hideMessage;
        setDisplay2(true)
        const { targetDepartments, companyDomainResearch, companyNameResearch, productsResearch, servicesResearch } = values
        const departmets = targetDepartments.join(",")

        // Check if this is a new search
        const isNewSearch =
            lastLeadsSearch?.companyDomainResearch !== companyDomainResearch ||
            lastLeadsSearch?.companyNameResearch !== companyNameResearch ||
            lastLeadsSearch?.departmets !== departmets ||
            JSON.stringify(lastLeadsSearch?.productsResearch) !== JSON.stringify(productsResearch) ||
            JSON.stringify(lastLeadsSearch?.servicesResearch) !== JSON.stringify(servicesResearch);

        // Reset offset and leads if it's a new search
        const currentOffset = isNewSearch ? 0 : dataOffset;

        const payload = {
            companyId: profile.companyId,
            department: departmets,
            domain: companyDomainResearch,
            offset: currentOffset,
            limit: dataLimit
        }
        try {
            hideMessage = message.loading("Loading leads...", 0);
            const responseData = await hunterioLeadReserach(payload)

            // Update last search parameters
            setLastLeadsSearch({
                companyDomainResearch,
                companyNameResearch,
                departmets,
                productsResearch,
                servicesResearch
            });

            // Check if there are more records available
            const hasMore = responseData.data.length >= dataLimit;
            setHasMoreLeads(hasMore);

            if (Array.isArray(responseData.data) && responseData.data.length === 0) {
                hideMessage();
                if (isNewSearch) {
                    message.info("No leads found for the selected departments or domain");
                    setResearchLeads([]);
                } else {
                    message.info("No more leads available");
                }
                setDisplay2(false);
                setHasMoreLeads(false);
                loadingRef.current = false;
                setDelteClick3(false)
                return;
            }

            if (isNewSearch) {
                // Fresh search - replace all data
                setResearchLeads(responseData.data.slice(0, dataLimit));
                setDataOffset(dataLimit);
            } else {
                // Load more - prepend new data
                setResearchLeads(prevLeads => [...responseData.data.slice(0, dataLimit), ...prevLeads]);
                setDataOffset(currentOffset + dataLimit);
            }
            loadingRef.current = false;
            setDelteClick3(false)
            hideMessage();
            setDisplay2(false)
        }
        catch (error) {
            loadingRef.current = false;
            setDelteClick3(false)
            hideMessage();
            setDisplay2(false)
            setHasMoreLeads(false);
            message.error(error)
            // message.error("The Hunter.io API key is invalid or not configured. Please contact your admin")
        }
    }
    const onSubmit2 = async (values) => {
        if (loadingRef.current) return;
        const { country, industry, instruction } = values
        const isNewSearch =
            lastSearch?.country !== country ||
            lastSearch?.industry !== industry ||
            lastSearch?.instruction !== instruction;
        const currentStoreLength = isNewSearch ? 0 : (companyList.display?.length ?? 0);
        if (currentStoreLength >= 100) {
            message.warning("Maximum limit reached");
            return;
        }
        loadingRef.current = true;
        setDelteClick6(true)
        setDisplay(true)
        const excludedCompaniesList = Array.from(
            new Set(
                (!isNewSearch ? (companyList.display || []) : [])
                    .map(item => item.company_name)
                    .filter(Boolean)
            )
        );
        const companies = excludedCompaniesList.length > 0 ? excludedCompaniesList.join(",") : null;
        const payload = {
            companyId: profile.companyId,
            industry,
            country,
            excludedCompanies: companies,
            additionalInstructions: instruction
        }
        try {
            setCompanyList(prev => ({ ...prev, identifier: prev.display?.length ? prev.display : null }))
            const responseData = await prospectDiscovery(payload)
            setLastSearch({
                industry,
                country,
                instruction
            })
            if (Array.isArray(responseData.prospects) && responseData.prospects.length === 0) {
                loadingRef.current = false;
                setDelteClick6(false)
                setDisplay(false)
                setCompanyList(prev => {
                    if (isNewSearch) {
                        return {
                            ...prev,
                            extraData: {
                                ...responseData.country_stock_exchange,
                                industry
                            },
                            identifier: [],
                        };
                    }
                    return {
                        ...prev,
                        identifier: prev.display
                    };
                });
                message.info("No accounts were found for the selected country and industry")
                return
            }
            const originalData = (responseData.prospects || [])
            setCompanyList(prev => {
                const newStore = isNewSearch
                    ? [...originalData]
                    : [...(prev?.display || []), ...originalData];
                // const sortOrdr = newStore.sort((a, b) => b.fit_score - a.fit_score)
                // const OsortOrdr = originalData.sort((a, b) => b.fit_score - a.fit_score)
                return {
                    identifier: originalData,
                    display: newStore,
                    extraData: {
                        ...responseData.country_stock_exchange,
                        industry
                    }
                }
            });
            setDisplay(false)
            loadingRef.current = false;
            setDelteClick6(false)
            message.success(`${originalData.length} accounts retrieved successful`);
        }
        catch (error) {
            loadingRef.current = false;
            setDelteClick6(false)
            setDisplay(false)
            message.error(String(error));
        }
    }
    const handleValuesChange = (_, allValues) => {
        const { companyName, companyDomain } = allValues;
        const hasCompanyName = companyName?.trim();
        const hasCompanyDomain = companyDomain?.trim();
        const hasValue = !!(hasCompanyName || hasCompanyDomain);
        setIsFormFilled(hasValue);
    };
    const handleValuesChange1 = (_, allValues) => {
        const { country, industry } = allValues;
        const hasCompanyName = country?.trim();
        const hasCompanyDomain = industry?.trim();
        const hasValue = !!(hasCompanyName || hasCompanyDomain);
        setIsFormFilled2(hasValue);
    };
    const handleValuesChange2 = (_, allValues) => {
        const { companyNameResearch, companyDomainResearch, productsResearch, servicesResearch } = allValues;

        // Trim strings and check if non-empty
        const hasCompanyName = companyNameResearch?.trim();
        const hasCompanyDomain = companyDomainResearch?.trim();
        const hasProducts = productsResearch?.length;
        const hasServices = servicesResearch?.length;

        const hasValue = !!(hasCompanyName || hasCompanyDomain || hasProducts || hasServices);

        setIsFormFilled1(hasValue);
    };
    const departmentMapping = (departments) => {
        Modal.info({
            title: "Recommended Target Departments",
            icon: null,
            width: 700,
            closable: true,
            content: (
                <DepartmentModal
                    companyId={profile.companyId}
                    hunderDepartments={departments}
                    selectedCommaSeparated={selectedDepartments}
                    onSave={(commaSeparated) => { setSelectedDepartments(commaSeparated); form1.setFieldsValue({ targetDepartments: commaSeparated }) }}
                />
            ),
            className: "customice-confirm-modal1",
            centered: true,
            footer: false
        });
    };
    const getTargetDepartmentsData = async () => {
        let hideMessage;
        try {
            const productIds = form1.getFieldValue('productsResearch') || [];
            const serviceIds = form1.getFieldValue('servicesResearch') || [];
            if (!productIds?.length && !serviceIds?.length) {
                message.warning("Please select at least one product or service");
                return;
            }
            setDisplay2(true);
            hideMessage = message.loading("Loading target departments...", 0);
            const [productResponses, serviceResponses] = await Promise.all([
                Promise.all(productIds?.map((id) => getProductDetails(id))),
                Promise.all(serviceIds?.map((id) => getServiceLineDetails(id)))
            ]);
            const productDepartments = productResponses?.flatMap(
                (res) => res?.targetDepartments?.split(",").map((d) => d.trim()) || []
            );
            const serviceDepartments = serviceResponses?.flatMap(
                (res) => res?.target_departments?.split(",").map((d) => d.trim()) || []
            );
            const allDepartments = [
                ...new Set([...productDepartments, ...serviceDepartments].filter(Boolean))
            ];
            hideMessage();
            departmentMapping(allDepartments)
        } catch (error) {
            hideMessage();
            setDisplay2(false);
            message.error("Failed to load departments");
        }
        finally {
            setDisplay2(false);
        }
    };
    const TableSkeleton = () => {
        const skeletonRowStyle = {
            padding: '13px 20px',
            height: '68px',
            borderBottom: '1px solid #f0f0f0',
        };
        return (
            <div>
                {Array.from({ length: 5 }).map((_, idx) => (
                    <div key={idx} style={skeletonRowStyle}>
                        <Skeleton
                            avatar={false}
                            paragraph={{ rows: 2, width: '100%' }}
                            active
                            title={false}
                        />
                    </div>
                ))}
            </div>
        );
    };
    const successMessage = (titles, data, type) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    {type === "Approve" ? <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> : <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />}
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => {
                modal.destroy();
            }
        });
    }
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const normalizeValue2 = (value) => value?.toLowerCase()?.trim() || '';
    const getSeniorityLevelId = (senioritys) => {
        const normalized = normalizeValue2(senioritys);
        const match = seniority.find(item =>
            item.option.toLowerCase().includes(normalized)
        );
        if (match) return match.customDropdownOptionId;
        const fallback = seniority.find(
            item => item.option === "Junior Management Level"
        );
        return fallback ? fallback.customDropdownOptionId : null;
    };
    const getIndustryId = (lead, industryDropdown) => {
        const industryName = lead.AccountData.CompanyIndustry
        if (industryName == null) {
            const fallback = industryDropdown.find(
                (item) => item.option === "Retail"
            );
            return fallback?.customDropdownOptionId || null;
        }
        const normalized = normalizeValue2(industryName);
        const match = industryDropdown.find(
            (item) => normalizeValue2(item.option) === normalized
        );
        if (match) return match.customDropdownOptionId;
        const fallback = industryDropdown.find(
            (item) => item.option === "Retail"
        );
        return fallback?.customDropdownOptionId || null;
    };

    const getLeadStatusSource = async () => {
        try {
            const statusDropdown = checkboxValues.find((item) => item.fieldKey === "leadStatusId")
            const statusOptions = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const statusDropdown1 = checkboxValues.find((item) => item.fieldKey === "leadSourceId")
            const sourceOptions = await findAllCustomOptionsByDropdown(statusDropdown1.dropdownId)
            const notContacted = statusOptions.find(
                (item) => item.option === "Not Contacted"
            );
            const thirdPartySource = sourceOptions.find(
                (item) => item.option === "Third-Party Lead Providers"
            );
            const statusId = notContacted?.customDropdownOptionId;
            const sourceId = thirdPartySource?.customDropdownOptionId;
            return {
                status: statusId || null,
                source: sourceId || null,
            };
        }
        catch (error) {
            message.error(error)
            return {
                status: null,
                source: null,
            };
        }
    }
    async function proceedLeadCreation(LeadData, sid) {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick2(true)
        let hideMessage;
        setDisplay2(true)
        try {
            hideMessage = message.loading("Adding as a lead...", 0);
            const Ids = await getLeadStatusSource()
            const companyName = form1.getFieldValue("companyNameResearch");
            const companyDomain = form1.getFieldValue("companyDomainResearch");
            const seniorityLevelId = sid ? Number(sid) : getSeniorityLevelId(LeadData?.employment?.seniority);
            const id = getIndustryId(dataForLeads, industryData);
            const payload =
            {
                seniorityLevelId: normalizeValue(seniorityLevelId),
                firstName: normalizeValue(LeadData?.name?.givenName),
                lastName: normalizeValue(LeadData?.name?.familyName),
                leadOwner: normalizeValue(profile.userId),
                designation: normalizeValue(LeadData?.employment?.title),
                accountName: normalizeValue(companyName),
                industry: normalizeValue(id),
                primaryEmail: normalizeValue(LeadData?.email),
                leadSourceId: normalizeValue(Ids?.source),
                leadStatusId: normalizeValue(Ids?.status),
                emailOptOut: normalizeValue(false),
                leadFiles: [],
                city: normalizeValue(LeadData?.geo?.city),
                country: normalizeValue(LeadData?.geo?.country ? LeadData.geo.country : dataForLeads?.AccountData?.Country ? dataForLeads.AccountData.Country : null),
                state: normalizeValue(LeadData?.geo?.state ? LeadData.geo.state : dataForLeads?.AccountData?.State ? dataForLeads.AccountData.State : null),
                website: normalizeValue(companyDomain),
                linkedinUrl: normalizeValue(LeadData?.linkedin?.handle ? `https://www.linkedin.com/in/${LeadData?.linkedin?.handle}` : null),
            }
            const dataLead = await LeadSave(payload)
            if (dataLead.status === 201) {
                hideMessage();
                const isAutomation = dataLead?.data === AutomationMessage;
                const isApproval = dataLead?.data === ApprovalMessage;
                setDisplay2(false)
                loadingRef.current = false;
                setDelteClick2(false)
                if (isApproval) {
                    successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                } else if (isAutomation) {
                    successMessage("Automation rule triggered", dataLead?.data);
                    if (pageFrom !== "Report") {
                        GetAll()
                    }
                } else {
                    message.success(dataLead?.data);
                    if (pageFrom !== "Report") {
                        GetAll()
                    }
                }
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDelteClick2(false)
            hideMessage();
            setDisplay2(false)
            message.error(error)
        }
    }
    async function AddasaLead(email) {
        let hideMessage;
        setDisplay2(true)
        try {
            hideMessage = message.loading("Adding as a lead...", 0);
            const response = await hunterioLeadDetails(profile.companyId, email)
            const LeadData = response.data
            const senioritylevel = normalizeValue(LeadData?.employment?.seniority)

            let modalInstance;
            if (!senioritylevel) {
                hideMessage();
                setDisplay2(false)

                modalInstance = Modal.confirm({
                    icon: null,
                    title: "Seniority Level Required",
                    content: (
                        <Select
                            style={{ width: "100%" }}
                            placeholder="Select Seniority Level"
                            onChange={(value) => {
                                selectedSeniorityRef.current = value;
                                if (modalInstance && modalInstance.update) {
                                    modalInstance.update({
                                        okButtonProps: { disabled: false }, // enable button when value selected
                                    });
                                }
                            }}
                        >
                            {seniority.map((options, i) => (
                                <Option value={options.customDropdownOptionId} key={i}>
                                    {options.option}
                                </Option>))}
                        </Select>
                    ),
                    className: "customice-confirm-modal",
                    centered: true,
                    okText: "Continue",
                    cancelText: "Cancel",
                    okButtonProps: { disabled: true }, // initially disabled
                    onOk() {
                        const finalSeniority = selectedSeniorityRef.current;
                        proceedLeadCreation(LeadData, finalSeniority);
                    },
                });
                return;
            }
            hideMessage();
            proceedLeadCreation(LeadData);
        }
        catch (error) {
            hideMessage();
            setDisplay2(false)
            message.error(error)
        }
    }
    const showConfirm2 = (value) => {
        const modal = Modal.confirm({
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, }}>
                    {/* <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> */}
                    <span>Adding Lead</span>
                </div>
            ),
            icon: null,
            content: (
                <p>Are you sure you want to add this lead?</p>
            ),
            className: "customice-confirm-modal",
            centered: true,
            okText: "Yes",
            cancelText: "No",
            okButtonProps: {
                className: "button_colorsModal"
            },
            cancelButtonProps: {
                className: "gray-buttonModal"
            },
            okCancel: true,
            onOk() {
                AddasaLead(value)
            },
            onCancel() {
                modal.destroy();
                setDisplay(false)
            },
        });
    };
    const handleChangeToResearch = (value) => {
        let domain = value.company_website?.trim();
        domain = domain.replace(/^https?:\/\//, '');
        if (!domain.startsWith('www.')) {
            domain = `www.${domain}`;
        }
        setActiveKey("1");
        form.setFieldsValue({
            companyName: value.company_name,
            companyDomain: domain,
        });
        // setActiveKey("1")
        // form.setFieldsValue({ companyName: value.company_name, companyDomain: value.company_website })
        setIsFormFilled(true);
        setIsFormFilled2(false);
        // setCompanyList({ display: null, extraData: null, identifier: [] })
        // form2.setFieldsValue({
        //     country: null,
        //     industry: null,
        //     instruction: null,
        // })
    }
    const handleOpenChange = (index) => {
        const newPopoverOpenStates = [...open];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpen(newPopoverOpenStates);
    };
    const openDetailsWindow = (data) => {
        setDataValue(data);
        setIsModalOpen(!isModalOpen);
    };
    const ServicesColumns = [
        {
            title: 'S.No',
            dataIndex: 'no',
            key: 'no',
            width: 100,
            ellipsis: true,
            render: (text, record, index) => (
                <Form.Item>
                    <Typography.Paragraph ellipsis={{ tooltip: false }} style={{ marginBottom: 0 }} title={index + 1}>
                        {index + 1}
                    </Typography.Paragraph>
                </Form.Item>
            ),
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '25%',
            ellipsis: true,
            render: (text, record) => (
                <Form.Item>
                    <Typography.Paragraph ellipsis={{ tooltip: false }} style={{ marginBottom: 0 }} title={`${record?.first_name} ${record?.last_name} (${record?.value})`}>
                        <div>
                            <div>
                                {`${record?.first_name} ${record?.last_name}`}
                            </div>
                            <div style={{ fontSize: 14, color: "#79828c", }}>
                                {record?.value}
                            </div>
                        </div>
                    </Typography.Paragraph>
                </Form.Item>
            ),
        },
        {
            title: 'Department',
            dataIndex: 'department',
            key: 'department',
            width: '15%',
            ellipsis: true,
            render: (text, record) => (
                <Form.Item>
                    <Typography.Paragraph ellipsis={{ tooltip: false }} style={{ marginBottom: 0 }} title={record?.department}>
                        {record?.department}
                    </Typography.Paragraph>
                </Form.Item>
            ),
        },
        {
            title: 'Designation',
            dataIndex: 'designation',
            key: 'designation',
            width: '25%',
            ellipsis: true,
            render: (text, record) => (
                <Form.Item>
                    <Typography.Paragraph ellipsis={{ tooltip: false }} style={{ marginBottom: 0 }} title={record?.position}>
                        {record?.position}
                    </Typography.Paragraph>
                </Form.Item>
            ),
        },
        {
            title: `Seniority Level`,
            dataIndex: 'seniorityLevel',
            key: 'seniorityLevel',
            width: '15%',
            ellipsis: true,
            render: (text, record) => (
                <Form.Item>
                    <Typography.Paragraph ellipsis={{ tooltip: false }} style={{ marginBottom: 0 }} title={record?.seniority}>
                        {record?.seniority}
                    </Typography.Paragraph>
                </Form.Item>
            ),
        },
        {
            title: 'Actions',
            dataIndex: 'addAction',
            key: 'addAction',
            width: 100,
            render: (text, record) => {
                const emailExists = AllLeads.some(
                    (lead) => lead.primary_email?.toLowerCase() === record.value?.toLowerCase()
                );
                if (record.value || profile.department !== "Sales") {
                    return (
                        <Button size="small" className={emailExists ? "gray-buttonModal" : "button_colors"} disabled={emailExists || display2 || deleteClick2} loading={deleteClick2} onClick={() => showConfirm2(record.value)}>
                            {emailExists ? "Added" : "Add"}
                        </Button>
                    );
                }
            },
        }
    ];
    const Contents = ({ datam, indexKey }) => (
        < div style={{
            padding: "0px 10px",
            width: "100%",
            height: "100%",
        }}>
            <div className="text_icon bulk_action" style={{ cursor: "pointer", marginBottom: 5 }} tabIndex={0} role="button" onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') { openDetailsWindow(datam); handleOpenChange(indexKey) }
            }} onClick={() => { openDetailsWindow(datam); handleOpenChange(indexKey) }}>
                <FeatherIcon icon="eye" size={16} className="text_iconspace" /> View Details
            </div>
            <div className="text_icon bulk_action" style={{ cursor: "pointer" }} tabIndex={0} role="button" onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') { handleChangeToResearch(datam); handleOpenChange(indexKey) }
            }} onClick={() => { handleChangeToResearch(datam); handleOpenChange(indexKey) }}>
                <ReseachAccountIcon height={15} width={15} marginRight={5} /> Research Account
            </div>
        </div >
    );
    Contents.propTypes = {
        indexKey: PropTypes.number.isRequired,
        datam: PropTypes.object.isRequired,
    };
    const CompanyColumns = [
        {
            title: 'S.No',
            dataIndex: 'no',
            key: 'no',
            width: '10%',
            ellipsis: true,
            render: (text, record, index) => (
                <Form.Item>
                    <Typography.Paragraph ellipsis={{ tooltip: false }} style={{ marginBottom: 0 }} title={index + 1}>
                        {index + 1}
                    </Typography.Paragraph>
                </Form.Item>
            ),
        },
        {
            title: 'Account Name',
            dataIndex: 'company_name',
            key: 'company_name',
            width: '45%',
            ellipsis: true,
            render: (text, record) => (
                <Form.Item>
                    <Typography.Paragraph ellipsis={{ tooltip: false }} style={{ marginBottom: 0 }} title={`${record?.company_name} (${record.company_website})`}>
                        <div><div>
                            {record?.company_name}</div>
                            <div>
                                {record?.company_website ? (
                                    <a
                                        href={record.company_website.startsWith('http')
                                            ? record.company_website :
                                            `https://${record.company_website}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {record.company_website}
                                    </a>
                                ) : (
                                    '-'
                                )
                                }</div>
                        </div>
                    </Typography.Paragraph>
                </Form.Item>
            ),
        },
        {
            title: 'Annual Revenue',
            dataIndex: 'estimated_revenue_range',
            key: 'estimated_revenue_range',
            width: '25%',
            ellipsis: true,
            render: (text, record) => (
                <Form.Item>
                    <Typography.Paragraph ellipsis={{ tooltip: false }} style={{ marginBottom: 0 }} title={record?.estimated_revenue_range}>
                        {record?.estimated_revenue_range}
                    </Typography.Paragraph>
                </Form.Item>
            ),
        },
        {
            title: 'Fit Score',
            dataIndex: 'fit_score',
            key: 'fit_score',
            width: '10%',
            ellipsis: true,
            render: (text, record) => (
                <Form.Item>
                    <Typography.Paragraph ellipsis={{ tooltip: false }} style={{ marginBottom: 0 }} title={record?.fit_score}>
                        {record?.fit_score}/100
                    </Typography.Paragraph>
                </Form.Item>
            ),
        },
        {
            title: 'Actions',
            dataIndex: 'addAction',
            key: 'addAction',
            width: 50,
            render: (text, record, index) => {
                if (!display) {
                    return (
                        <>
                            <Popover
                                placement="bottomLeft"
                                content={<Contents datam={record} indexKey={index} />}
                                trigger="hover"
                                open={open[index]}
                                onOpenChange={() => handleOpenChange(index)}
                            >
                                <FeatherIcon icon="more-vertical" style={{ cursor: "pointer" }} size={20} className="email-more" />
                            </Popover>
                        </>
                    );
                }
            },
        }
    ];
    const CompanyColumns1 = [
        {
            exportTitle: 'Account Name',
            key: 'company_name',
        },
        {
            exportTitle: 'Account website',
            key: 'company_website',
        },
        {
            exportTitle: 'Annual Revenue',
            key: 'estimated_revenue_range',
        },
        {
            exportTitle: 'Fit Score',
            key: 'fit_score',
        },
        {
            exportTitle: 'Description',
            key: 'description',
        },
        {
            exportTitle: `Selection Reason`,
            key: 'selection_reason',
        },
    ];
    const PageConent2 = (<AddUser>
        <div className="user-info-form">
            <BasicFormWrapper>
                <VerticalFormStyleWrap>
                    <Form style={{ width: '100%' }} form={form2} name="discover" onFinish={onSubmit2} onValuesChange={handleValuesChange1} onFinishFailed={onFinishFailed} colon={false}>
                        <div className="add-product-block">
                            <Row gutter={30} style={{ margin: "20px 0px 0px" }}>
                                <Col span={12} style={{ marginBottom: 20 }}>
                                    <Form.Item label="Country" name="country" id="country" rules={[{ message: 'Please select country', required: true }]} >
                                        <Select disabled={display}
                                            style={{ width: '100%' }}
                                            showSearch
                                            placeholder="Select Country"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {allCountry?.map((option) => (
                                                <Option key={option.countryId} value={option.country}>
                                                    {option.country}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={12} style={{ marginBottom: 20 }}>
                                    <Form.Item label="Industry" name="industry" id="industry" rules={[{ required: true, message: 'Please enter industry' }]}>
                                        <Select style={{ width: '100%' }}
                                            placeholder="Select Industry" disabled={display}
                                            showSearch
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {industryData.map((option, i) => (
                                                <Option value={option.option} key={i}>
                                                    {option.option}
                                                </Option>))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={24} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Additional Instructions" name="instruction" id="instruction">
                                        <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Instructions' disabled={display} />
                                    </Form.Item>
                                </Col>
                                <Col span={24} style={{ marginBottom: 30 }}>
                                    <Form.Item shouldUpdate>
                                        {({ getFieldValue }) => {
                                            const country = getFieldValue("country");
                                            const industry = getFieldValue("industry");
                                            const instruction = getFieldValue("instruction");
                                            const isDisabled = display || !country || !industry;
                                            const isNewSearch =
                                                lastSearch?.country !== country ||
                                                lastSearch?.industry !== industry ||
                                                lastSearch?.instruction !== instruction;
                                            let buttonText = "Discover Accounts";
                                            if (companyList.display?.length > 0 && !isNewSearch) {
                                                buttonText = "Discover More Accounts";
                                            } else if (isNewSearch) {
                                                buttonText = "Discover Accounts";
                                            }
                                            return (
                                                <Button
                                                    size="small"
                                                    block
                                                    htmlType="submit"
                                                    className="gradient-button"
                                                    disabled={isDisabled || deleteClick6}
                                                    loading={deleteClick6}
                                                >
                                                    {!deleteClick6 && <AiIcon />} {buttonText}
                                                </Button>
                                            );
                                        }}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                    <div className="add-product-block">
                        <Row gutter={30} style={{ marginTop: 0 }}>
                            <Col span={24} style={{ marginBottom: 20 }}><div className="table-bordered leaderboard-table table-responsive">
                                <Table
                                    dataSource={companyList.display}
                                    columns={CompanyColumns}
                                    rowKey={(record, index) => index?.toString()}
                                    pagination={false}
                                    tableLayout="fixed"
                                    locale={{
                                        emptyText: !companyList.identifier ? (
                                            <TableSkeleton rows={5} />
                                        ) : companyList.identifier.length === 0 ? (
                                            <Empty />
                                        ) : null,
                                    }}
                                />
                            </div>
                            </Col>
                        </Row>
                    </div>
                </VerticalFormStyleWrap>
            </BasicFormWrapper>
        </div>
    </AddUser>)
    const PageConent = (<AddUser>
        <div className="user-info-form">
            <BasicFormWrapper>
                <VerticalFormStyleWrap>
                    <Form style={{ width: '100%' }} form={form} name="info" onFinish={onSubmit} onValuesChange={handleValuesChange} onFinishFailed={onFinishFailed} colon={false}>
                        <div className="add-product-block">
                            <Row gutter={30} style={{ margin: "20px 0px 0px" }}>
                                <Col span={12} style={{ marginBottom: 20 }}>
                                    <Form.Item label="Account Name" name="companyName"
                                        id="companyName"
                                        rules={[{ required: true, message: 'Please enter account name' }]}>
                                        <Input placeholder="Enter account name" disabled={display} />
                                    </Form.Item>
                                </Col>
                                <Col span={12} style={{ marginBottom: 20 }}>
                                    <Form.Item label="Account Web URL" name="companyDomain"
                                        id="companyDomain"
                                        rules={[{ required: true, message: 'Please enter account web URL' }, {
                                            pattern: /^(?!https?:\/\/)(?!.*\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
                                            message: 'Enter a valid URL (e.g., example.com, sub.example.co.in) without http/https or "/"',
                                        },]}>
                                        <Input placeholder="Enter account web URL" disabled={display} />
                                    </Form.Item>
                                </Col>
                                <Col span={24} style={{ marginBottom: 30 }}>
                                    <Form.Item shouldUpdate>
                                        {({ getFieldValue }) => {
                                            const companyName = getFieldValue("companyName");
                                            const companyDomain = getFieldValue("companyDomain");
                                            const isDisabled = display || !companyName || !companyDomain;
                                            return (
                                                <Button
                                                    size="small"
                                                    block
                                                    htmlType="submit"
                                                    className="gradient-button"
                                                    disabled={isDisabled || deleteClick4}
                                                    loading={deleteClick4}
                                                >
                                                    {!deleteClick4 && <AiIcon />} Research Account
                                                </Button>
                                            );
                                        }}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                    <div className="add-product-block">
                        <Row gutter={30} style={{ margin: "0px 0px 20px" }}>
                            <Col span={24} style={{ marginBottom: 10 }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <Heading as="h5">Account Intelligence Report</Heading>
                                    <Button size="small" className="button_colors" disabled={!researchContent || display} onClick={() => downoadFile("Download PDF")}>
                                        <FeatherIcon icon='download' /> Download Report
                                    </Button>
                                </div>
                            </Col>
                            <Col span={24} style={{ marginBottom: 20 }}>
                                {researchContent ?
                                    currency ?
                                        <div style={{
                                            border: "2px solid #eee",
                                            padding: "20px 0px 20px 20px",
                                            borderRadius: "10px",
                                        }}>
                                            <CustomHtmlParser html={researchContent}
                                                key={currency} />
                                        </div> : <></>
                                    :
                                    display ? <div style={{
                                        border: "2px solid #eee",
                                        padding: "20px 0px 20px 20px",
                                        borderRadius: "10px",
                                    }}>
                                        <Spin
                                            tip="Generating report" size="small">
                                            {content}
                                        </Spin>
                                    </div>
                                        : <Input.TextArea rows={5} disabled />}
                            </Col>
                        </Row>
                    </div>
                </VerticalFormStyleWrap>
            </BasicFormWrapper>
        </div>
    </AddUser>)
    const PageConent1 = (<AddUser>
        <div className="user-info-form">
            <BasicFormWrapper>
                <VerticalFormStyleWrap>
                    <Form style={{ width: '100%' }} form={form1} name="info" onFinish={onSubmit1} onValuesChange={handleValuesChange2} onFinishFailed={onFinishFailed} colon={false}>
                        <div className="add-product-block">
                            <Row gutter={30} style={{ margin: "20px 0px 0px" }}>
                                <Col span={12} style={{ marginBottom: 20 }}>
                                    <Form.Item label="Account Name" name="companyNameResearch"
                                        id="companyNameResearch"
                                        rules={[{ required: true, message: 'Please enter account name' }]}>
                                        <Input placeholder="Enter account name" disabled={dataForLeads.fieldDisable || display2} />
                                    </Form.Item>
                                </Col>
                                <Col span={12} style={{ marginBottom: 20 }}>
                                    <Form.Item label="Account Web URL" name="companyDomainResearch"
                                        id="companyDomainResearch"
                                        rules={[{ required: true, message: 'Please enter account web URL' }, {
                                            pattern: /^(?!https?:\/\/)(?!.*\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
                                            message: 'Enter a valid URL (e.g., example.com, sub.example.co.in) without http/https or "/"',
                                        },]}>
                                        <Input placeholder="Enter account web URL" disabled={dataForLeads.fieldDisable || display2} />
                                    </Form.Item>
                                </Col>
                                <Col span={12} style={{ marginBottom: 20 }}>
                                    <Form.Item label="Target Products" name="productsResearch"
                                        id="productsResearch"
                                    // rules={[{ required: true, message: 'Please select target products' }]}
                                    >
                                        <Select style={{ width: '100%' }} placeholder="Select Target Products"
                                            showSearch className='MultiUiNew2' mode='multiple' disabled={display2}
                                            optionFilterProp="children" optionLabelProp="label"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }>
                                            {productList?.map((option, i) => (
                                                <Option value={option.dealProductId} key={i} label={option.productName}>
                                                    <div className='UserList-dropdown' title={`${option.productName} (${option.prodcutCategory})`}>
                                                        <div>
                                                            {option.productImg !== null && option.productImg !== undefined && option.productImg !== "" ?
                                                                < img src={option.productImg} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                :
                                                                <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                    {option.productName?.slice(0, 1).toUpperCase()}
                                                                </span>
                                                            }
                                                        </div>
                                                        <div>
                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.productName}</p>
                                                            <p style={{ margin: 0 }}>({option.prodcutCategory})</p>
                                                        </div>
                                                    </div>
                                                </Option>))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={12} style={{ marginBottom: 20 }}>
                                    <Form.Item label="Target Services" name="servicesResearch"
                                        id="servicesResearch"
                                    // rules={[{ required: true, message: 'Please select target services' }]}
                                    >
                                        <Select style={{ width: '100%' }} placeholder="Select Target Services"
                                            showSearch className='MultiUiNew2' mode='multiple' disabled={display2}
                                            optionFilterProp="children" optionLabelProp="label"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }>
                                            {serviceList?.map((option, i) => (
                                                <Option value={option.serviceLineId} key={i} label={option.serviceName
                                                }>
                                                    <div className='UserList-dropdown' title={option.serviceName}>
                                                        <div>
                                                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                {option.serviceName?.slice(0, 1).toUpperCase()}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.serviceName}</p>
                                                        </div>
                                                    </div>
                                                </Option>))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Row align="middle" gutter={16} style={{ marginBottom: 20 }}>
                                        <Col span={22}>
                                            <Form.Item label="Target Departments" name="targetDepartments"
                                                id="targetDepartments"
                                                rules={[{ required: true, message: 'Please select target department' }]}>
                                                <Select
                                                    mode="tags"
                                                    className="MultiUiNew3"
                                                    style={{
                                                        width: "100%",
                                                        pointerEvents: "none",
                                                        backgroundColor: "#fafafa",
                                                    }}
                                                    placeholder="Target Departments"
                                                    tokenSeparators={[","]}
                                                    open={false}
                                                    options={HunterioDepartments}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={2} style={{ marginTop: 5 }}>
                                            <Form.Item label=" " style={{ textAlign: "end" }}>
                                                <Button size="small" className="button_outlined" disabled={display2}
                                                    onClick={() => getTargetDepartmentsData()}
                                                >
                                                    Select
                                                </Button></Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={24} style={{ marginBottom: 30 }}>
                                    <Form.Item shouldUpdate>
                                        {({ getFieldValue }) => {
                                            const companyName = getFieldValue("companyNameResearch");
                                            const companyDomain = getFieldValue("companyDomainResearch");
                                            const department = getFieldValue("targetDepartments");
                                            const productsResearch = getFieldValue("productsResearch");
                                            const servicesResearch = getFieldValue("servicesResearch");

                                            // Check if this is a new search
                                            const isNewSearch =
                                                lastLeadsSearch?.companyDomainResearch !== companyDomain ||
                                                lastLeadsSearch?.companyNameResearch !== companyName ||
                                                lastLeadsSearch?.departmets !== department?.join(",") ||
                                                JSON.stringify(lastLeadsSearch?.productsResearch) !== JSON.stringify(productsResearch) ||
                                                JSON.stringify(lastLeadsSearch?.servicesResearch) !== JSON.stringify(servicesResearch);

                                            const isDisabled = display || !companyName || !companyDomain || !department?.length || (!isNewSearch && !hasMoreLeads);

                                            let buttonText = "Find Leads";
                                            if (researchLeads.length > 0 && !isNewSearch) {
                                                buttonText = hasMoreLeads ? "Find More Leads" : "Find Leads";
                                            }
                                            if (isNewSearch) {
                                                buttonText = "Find Leads";
                                            }
                                            return (
                                                <Button
                                                    size="small"
                                                    block
                                                    htmlType="submit"
                                                    className="gradient-button"
                                                    disabled={isDisabled || display2 || deleteClick3}
                                                    loading={deleteClick3}
                                                >
                                                    {!deleteClick3 && <AiIcon />}{buttonText}
                                                </Button>
                                            );
                                        }}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                    <div className="add-product-block">
                        <Row gutter={30} style={{ marginTop: 0 }}>
                            <Col span={24} style={{ marginBottom: 20 }}><div className="table-bordered leaderboard-table table-responsive">
                                <Table
                                    dataSource={researchLeads}
                                    columns={ServicesColumns}
                                    rowKey={(record, index) => index?.toString()}


                                    pagination={false}
                                    tableLayout="fixed"
                                    locale={{
                                        emptyText: !researchLeads ? (
                                            <TableSkeleton rows={5} />
                                        ) : researchLeads.length === 0 ? (
                                            <Empty />
                                        ) : null,
                                    }}
                                />
                                {researchLeads.length > 0 && !hasMoreLeads && (
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '20px',
                                        color: '#999',
                                        fontSize: '14px',
                                        borderTop: '1px solid #f0f0f0'
                                    }}>
                                        No more data available
                                    </div>
                                )}
                            </div>
                            </Col>
                        </Row>
                    </div>
                </VerticalFormStyleWrap>
            </BasicFormWrapper>
        </div>
    </AddUser >)
    const items = [
        {
            key: '3',
            label: 'Discover Accounts',
            children: PageConent2,
            disabled: isFormFilled1 || isFormFilled,
        },
        {
            key: '1',
            label: 'Research Account',
            children: PageConent,
            disabled: isFormFilled1 || isFormFilled2,
        },
        {
            key: '2',
            label: 'Find Leads',
            children: PageConent1,
            disabled: isFormFilled || isFormFilled2,
        },
    ];
    const onChange = async (key) => {
        setActiveKey(key);
        if (key === "3") {
            // const values = await form2.validateFields()
            // const hasCompanyName = values.country?.trim();
            // const hasCompanyDomain = values.industry?.trim();
            // const hasValue = !!(hasCompanyName || hasCompanyDomain);
            // setIsFormFilled2(hasValue)
        }
    };
    async function getAllPrdandService() {
        try {
            const data = await CompanyDataByUser();
            const products = data?.targetProducts || [];
            const services = data?.targetServiceLines || [];
            setProductList(products);
            setServiceList(services);
            // ✅ Show popup if both are empty
            if (products.length === 0 && services.length === 0) {
                message.warning(
                    <>
                        No <strong>products</strong> or <strong>services</strong> found.
                        To make a selection, please first create them and then assign them under{" "}
                        <strong>Target Products</strong> or{" "}
                        <strong>Target Services</strong> in the{" "}
                        <strong>My Company</strong> section.
                    </>
                );
            }
        } catch (error) {
            setProductList([]);
            setServiceList([]);
            message.error(error || "Something went wrong");
        }
    }
    async function IndustryDataApi() {
        try {
            const statusDropdown = checkboxValues.find((item) => item.fieldKey === "industry")
            const data = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const OriginalOrder = data.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
            setIndustryData(OriginalOrder)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            setAllCountry(response)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getSeniorityLevel = async () => {
        try {
            const statusDropdown = checkboxValues.find((item) => item.fieldKey === "seniorityLevelId")
            const data = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const OriginalOrder = data.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
            setSeniority(OriginalOrder)
        }
        catch (error) {
            message.error(error)
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            getAllPrdandService(),
            IndustryDataApi(),
            getSeniorityLevel(),
        ])
    };
    const fetchAll1 = async () => {
        await Promise.allSettled([
            getCountry(),
            IndustryDataApi(),
        ])
    };
    async function getColumnConfig() {
        try {
            const allFieldsRaw = await getAllCustomFieldByCompanyAndEntity(ENTITY_ID);
            const allFields = [...allFieldsRaw].sort((a, b) => {
                if (a.fieldGroupSortOrder !== b.fieldGroupSortOrder) {
                    return a.fieldGroupSortOrder - b.fieldGroupSortOrder;
                }
                return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
            });
            const structure = allFields.reduce((acc, field) => {
                // if (field.fieldVisible === 'No') return acc;
                if (field.fieldKey === "lastName") return acc;
                if (field.fieldType === "FileUpload") return acc;
                if (field.fieldType === "MultiFileUpload") return acc;
                if (field.fieldKey === "firstName") {
                    acc.push({
                        isChecked: true,
                        id: field.fieldId,
                        name: "Name",
                        entityId: field.entityId,
                        fieldKey: "name",
                        fieldType: field.fieldType,
                        dropdownId: field.dropdownId,
                        dropdownType: field.dropdownType,
                        customFieldType: field.customFieldType,
                    });
                    return acc;
                }
                acc.push({
                    isChecked: true,
                    id: field.fieldId,
                    name: field.fieldLabel,
                    entityId: field.entityId,
                    fieldKey: field.fieldKey,
                    fieldType: field.fieldType,
                    dropdownId: field.dropdownId,
                    dropdownType: field.dropdownType,
                    customFieldType: field.customFieldType,
                });
                return acc;
            }, []);
            structure.push(
                {
                    isChecked: true,
                    id: "lead_score",
                    name: "Lead Score",
                    entityId: null,
                    fieldKey: "lead_score",
                    fieldType: "Number",
                    dropdownId: null,
                    dropdownType: null,
                    customFieldType: null,
                },
                {
                    isChecked: true,
                    id: "created_at",
                    name: "Created Date",
                    entityId: null,
                    fieldKey: "created_at",
                    fieldType: "Date",
                    dropdownId: null,
                    dropdownType: null,
                    customFieldType: null,
                },
                {
                    isChecked: true,
                    id: "modified_at",
                    name: "Modified Date",
                    entityId: null,
                    fieldKey: "modified_at",
                    fieldType: "Date",
                    dropdownId: null,
                    dropdownType: null,
                    customFieldType: null,
                }
            );
            setCheckboxValues(structure)
        } catch (error) {
            message.error(error);
        }
    }
    const OpenResearchLead = (data, jsonData) => {
        setActiveKey("2")
        setDataForLeads({ AccountData: jsonData, fieldDisable: true })
        form1.setFieldsValue({ companyNameResearch: data.companyName, companyDomainResearch: data.companyDomain })
        setIsFormFilled1(true);
    }
    const SaveReport = async (value) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        if (value === "Save") {
            setDelteClick1(true)
        } else {
            setDelteClick(true)
        }
        setDisplay(true)
        let hideMessage;
        const values = await form.validateFields();
        const jsonData =
            typeof researchJson === "string"
                ? JSON.parse(researchJson)
                : researchJson
        const payload = {
            accountName: values.companyName,
            accountWebsite: values.companyDomain,
            accountIntelligenceReport: researchContent,
            accountIntelligenceJson: jsonData
        }
        try {
            hideMessage = message.loading("loading...", 0);
            await saveAccountInteReport(payload)
            hideMessage();
            loadingRef.current = false;
            if (value === "Save") {
                setDelteClick1(false)
            } else {
                setDelteClick(false)
            }
            setDisplay(false)
            message.success("Account intelligence report saved")
            if (value === "Save") {
                closeDrawer()
            }
            else {
                OpenResearchLead(values, jsonData)
            }
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            if (value === "Save") {
                setDelteClick1(false)
            } else {
                setDelteClick(false)
            }
            setDisplay(false)
            message.error(error)
        }
    }
    const SaveReport2 = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick7(true)
        setDisplay(true)
        let hideMessage;
        const payload = {
            accountDiscoverName: values.reportName,
            industry: values.industry,
            country: values.country,
            accountDiscoverJson: companyList.display
        }
        try {
            hideMessage = message.loading("loading...", 0);
            await createAccountDiscover(payload)
            hideMessage();
            loadingRef.current = false;
            setDelteClick7(false)
            setDisplay(false)
            message.success("Account discovery report saved")
            closeDrawer()
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDelteClick7(false)
            setDisplay(false)
            message.error(error)
        }
    }
    const showConfirm = (value) => {
        const modal = Modal.confirm({
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span>Report Exist</span>
                </div>
            ),
            icon: null,
            content: (
                <p>A report for this domain is already available. Saving may override the current report</p>
            ),
            className: "customice-confirm-modal",
            centered: true,
            okText: "Cancel",
            cancelText: "Save",
            okButtonProps: {
                className: "gray-buttonModal"
            },
            cancelButtonProps: {
                className: "button_colorsModal"
            },
            okCancel: true,
            onOk() {
                modal.destroy();
                setDisplay(false)
            },
            onCancel() {
                SaveReport(value)
            },
        });
    };
    const showConfirm3 = () => {
        Modal.info({
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span>Report Exist</span>
                </div>
            ),
            icon: null,
            content: (
                <p>A report with this name already exists. Please use a different name and try again</p>
            ),
            className: "customice-confirm-modal",
            centered: true,
        });
    };
    const SaveReportCehcking = async (value) => {
        const values = await form.validateFields();
        setDisplay(true)
        try {
            const resposne = await fetchDomainAvaliability(values.companyDomain)
            if (resposne === "") {
                SaveReport(value)
            }
            else {
                showConfirm(value)
            }
        } catch (error) {
            setDisplay(false)
            message.error(error)
        }
    }
    const SaveReportCehcking2 = async (value) => {
        let reportName = "";
        Modal.confirm({
            icon: null,
            title: <div style={{ display: 'flex', alignItems: 'center', gap: 5, }}>
                {/* <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> */}
                <span>Enter Report Name</span>
            </div>,
            content: (
                <Input
                    placeholder="Report Name"
                    onChange={(e) => {
                        reportName = e.target.value;
                    }}
                />
            ),
            className: "customice-confirm-modal",
            centered: true,
            okText: "Save",
            cancelText: "Cancel",
            okButtonProps: {
                className: "button_colorsModal"
            },
            cancelButtonProps: {
                className: "gray-buttonModal"
            },
            // okCancel: true,
            async onOk() {
                if (!reportName) {
                    message.error("Please enter a report name");
                    return
                }
                setDisplay(true)
                try {
                    const resposne = await findAccountDiscoverByName(reportName)
                    if (resposne === "") {
                        SaveReport2({ ...value, reportName })
                    }
                    else {
                        showConfirm3({ ...value, reportName })
                    }
                } catch (error) {
                    setDisplay(false)
                    message.error(error)
                }
            },
        });
    }
    useEffect(() => {
        if (checkboxValues?.length) {
            if (currency && activeKey === "2") {
                fetchAll()
            }
            if (currency && activeKey === "3") {
                fetchAll1()
            }
        }
    }, [checkboxValues])
    useEffect(() => {
        if (currency && (activeKey === "2" || activeKey === "3")) {
            setCheckboxValues()
            getColumnConfig()
        }
    }, [activeKey, currency])
    useEffect(() => {
        if (currency && pageFrom === "Report") {
            if (openResearchType === "Find Lead") {
                OpenResearchLead({ companyName: dataFrom?.accountName, companyDomain: dataFrom?.accountWebsite }, dataFrom?.accountIntelligenceJson)
                form.setFieldsValue({
                    companyName: null,
                    companyDomain: null,
                });
                form2.setFieldsValue({
                    country: undefined,
                    industry: undefined,
                    instruction: undefined
                })
                setResearchContent()
                setResearchJson()
                setDelteClick4(false)
                setIsFormFilled(false)
                setdispayData()
                setIsFormFilled2(false);
                setDelteClick6(false)
                setDisplay(false)
                setLastSearch({})
                setCompanyList({ display: [], extraData: null, identifier: [] })
            }
            else if (openResearchType === "Research Account") {
                handleChangeToResearch(dataFrom)
                form1.setFieldsValue({
                    companyNameResearch: null,
                    companyDomainResearch: null,
                    productsResearch: [],
                    servicesResearch: [],
                    targetDepartments: []
                })
                form2.setFieldsValue({
                    country: undefined,
                    industry: undefined,
                    instruction: undefined
                })
                setIsFormFilled1(false);
                setHasMoreLeads(true)
                setDataOffset(0)
                setLastLeadsSearch({})
                setResearchLeads([])
                setDisplay2(false)
                setDelteClick3(false)
                setIsFormFilled2(false);
                setDelteClick6(false)
                setDisplay(false)
                setLastSearch({})
                setDataForLeads({ AccountData: {}, fieldDisable: false })
                setCompanyList({ display: [], extraData: null, identifier: [] })
            }
        }
        else if (currency && pageFrom !== "Report") {
            // if (activeKey === "1") {
            //     if (!deleteClick4 && !researchContent) {
            //         form.setFieldsValue({
            //             companyName: undefined,
            //             companyDomain: undefined,
            //         })
            //         setActiveKey('3')
            //     }
            //     setResearchContent(researchContent)
            // }
            // else
            //     if (activeKey === "3") {
            //         if (!deleteClick6 && companyList.display?.length === 0) {
            //             form2.setFieldsValue({
            //                 country: undefined,
            //                 industry: undefined,
            //                 instruction: undefined
            //             })
            //         }
            //         setCompanyList(companyList)
            //     }
            //     else {
            //         setActiveKey('3')
            //     }
        }
        setPageLoading("Open")
    }, [currency])
    const reportExport = (value) => {
        setExportType1(value)
        setExportOpen1(!exportOpen1)
    }
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                closable={false}
                placement="right"
                title="Research Assistant"
                open={currency}
                width="80%"
                extra={
                    < Space >
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Minimize'
                            onClick={() => { PageMinimize() }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageMinimize()
                                }
                            }}
                            aria-label='Minimize'
                        > <FeatherIcon icon='minimize-2' size={24} /> </div>
                        {!(deleteClick4 || deleteClick6) && (
                            <div
                                className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0}
                                title='Close'
                                onClick={() => { PageCancel1() }}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        PageCancel1()
                                    }
                                }}
                                aria-label='Close'
                            >
                                <CancelIcon width={24} height={24} />
                            </div>
                        )}
                    </Space >
                }
                footer={((activeKey === "1" || activeKey === 1) && researchContent) ?
                    [<div className="form_action_button">
                        <Button size="small" className="button_colors" disabled={!researchContent || display || deleteClick1} loading={deleteClick1} onClick={() => SaveReportCehcking("Save")}>
                            {!deleteClick1 && <FeatherIcon icon='save' />} Save
                        </Button>
                        <Button size="small" className="button_colors" disabled={!researchContent || display || deleteClick} loading={deleteClick} onClick={() => SaveReportCehcking()}>
                            {!deleteClick && <FeatherIcon icon='save' />} Save & Find Leads
                        </Button>
                    </div>] : ((activeKey === "3" || activeKey === 3) && companyList.display?.length) ?
                        [<div className="form_action_button">
                            <Button size="small" className="button_colors" disabled={display} onClick={() => reportExport("Download CSV")}>
                                {!deleteClick1 && <FeatherIcon icon="share" size={15} className="text_iconspace" />} Export CSV
                            </Button>
                            <Button size="small" className="button_colors" disabled={display || deleteClick7} loading={deleteClick7} onClick={() => SaveReportCehcking2()}>
                                {!deleteClick && <FeatherIcon icon='save' />} Save & Close
                            </Button>
                        </div>]
                        : false}
            >
                {pageLoading ?
                    <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                        <div style={{ margin: "20px 40px" }}>
                            <Tabs activeKey={activeKey} items={items} onChange={onChange} className='Settings-page-tab' />
                        </div> </Scrollbars> :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer>
            {exportOpen ? <Modal title={exportType} open={exportOpen} maskClosable={false} onCancel={() => exportToCSV()} footer={false}>
                <ReportExport pageType={exportType} displayData={displayData} callBack={exportToCSV} pageFrom="Research" pdfData={pdfData} />
            </Modal> : ""}
            {exportOpen1 ? <Modal title={exportType1} open={exportOpen1} maskClosable={false} onCancel={() => reportExport()} footer={false}>
                <ReportExport pageType={exportType1} ColumData={CompanyColumns1} RowData={companyList.display} name={`DiscoverAccounts(${companyList.extraData.country}-${companyList.extraData.industry})`} callBack={reportExport} pageFrom="Forcast" />
            </Modal> : ""}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={closeDrawer} />}
            {isModalOpen ?
                <Modal
                    open={isModalOpen}
                    onCancel={openDetailsWindow}
                    footer={null}
                    centered
                    width={800}
                    title="Account Details"
                >
                    <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <VerticalFormStyleWrap>
                                    <Form style={{ width: '100%' }} colon={false}>
                                        <div className="add-product-block">
                                            <Row gutter={30} style={{ margin: "20px 0px 0px" }}>
                                                <Col span={12} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Account Name">
                                                        {dataValue.company_name}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Account Website" >
                                                        {dataValue?.company_website ? (
                                                            <a
                                                                href={
                                                                    dataValue.company_website.startsWith("http")
                                                                        ? dataValue.company_website
                                                                        : `https://${dataValue.company_website}`
                                                                }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {dataValue.company_website}
                                                            </a>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Annual Revenue" >
                                                        {dataValue.estimated_revenue_range}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12} style={{ marginBottom: 30 }}>
                                                    <Form.Item label="Fit Score">
                                                        {dataValue.fit_score}/100
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24} style={{ marginBottom: 30 }}>
                                                    <Form.Item label="Description">
                                                        {dataValue.description}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24} style={{ marginBottom: 30 }}>
                                                    <Form.Item label="Selection Reason">
                                                        {dataValue.selection_reason}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Form>
                                </VerticalFormStyleWrap>
                            </BasicFormWrapper>
                        </div>
                    </AddUser>
                </Modal>
                : ""}
        </>
    );
};

Popup.propTypes = {
    currency: PropTypes.bool.isRequired,
    AllLeads: PropTypes.array.isRequired,
    GetAll: PropTypes.func.isRequired,
    pageFrom: PropTypes.string.isRequired,
    dataFrom: PropTypes.object.isRequired,
    openResearchType: PropTypes.string.isRequired,
};

export default Popup;


